import { useEffect } from 'react';

import { useIsMutating } from '@tanstack/react-query';

import { useUpdateRentingPlanMutation } from '@telialt/core-eshop/src/hooks/mutations/useUpdateRentingPlanMutation';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ESHOP_MUTATION_KEY } from '@telialt/core-eshop/src/model';
import { ContractType, RentingPeriod } from '@telialt/models/src/EshopModel';
import { selectRentPlan } from '@telialt/utils/src/eshopSelectors';

export const useInitializeRentPlan = () => {
    const { cart } = useCartQuery();
    const { updateRentingPlan } = useUpdateRentingPlanMutation();
    const selectedRentingPlan = selectRentPlan(cart);

    const isChangingContractType = !!useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.UPDATE_CONTRACT_TYPE] });

    const withoutInitialRentingPlan =
        cart.contractType === ContractType.Renting && !selectedRentingPlan && cart.possibleRentingPlans?.length;

    const possibleRentPeriods = cart.possibleRentingPlans.map((p) => p.rentingPeriod);

    const priorityRent =
        [RentingPeriod.Months24, RentingPeriod.Months12, RentingPeriod.Months36].find((period) =>
            possibleRentPeriods.includes(period),
        ) || cart.possibleRentingPlans[cart.possibleRentingPlans?.length - 1]?.rentingPeriod;

    useEffect(() => {
        if (!isChangingContractType && withoutInitialRentingPlan && priorityRent) {
            updateRentingPlan(priorityRent);
        }
    }, [isChangingContractType, withoutInitialRentingPlan, priorityRent, updateRentingPlan]);
};
